import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { patientAnswers, questionnaireData, questions, retakeQuestionnaire } from '../mockData/patient-answers-data';

let index = 0;

const PatientAnswersApi = [
  rest.get(`${API_ROOT}patient-answers`, (req, res, ctx) => {
    const includeQuestions = req.url.searchParams.get('include_questions');
    const answersCount = req.url.searchParams.get('answers_count');
    const completed = req.url.searchParams.get('completed');
    const patientId = req.url.searchParams.get('patientId');
    if (includeQuestions === 'true') {
      return res(ctx.json(patientAnswers));
    }
    if (answersCount === 'true') {
      return res(ctx.json({ count: 1 }));
    }
    if (completed === 'true' || patientId === '200') {
      return res(ctx.json(questionnaireData));
    }
    return res(ctx.json({ data: [] }));
  }),
  rest.post(`${API_ROOT}questionnaire/743`, (req, res, ctx) => {
    const { retake, questionId } = req.body;
    if (retake) {
      return res(ctx.json(retakeQuestionnaire));
    }
    if (questionId) {
      const isLast = index === retakeQuestionnaire.questionnaire.length - 1;
      satisfyQuestionnaire(index, isLast);
      index += 1;
      return res(ctx.json(retakeQuestionnaire));
    }
    return res(ctx.json(questions));
  }),
];
const satisfyQuestionnaire = (idx, isLast) => {
  if (!isLast) {
    retakeQuestionnaire.questionnaire[idx].userAnswer.fromPrevious = false;
    retakeQuestionnaire.questionnaire[idx].userAnswer.isCurrent = false;
    retakeQuestionnaire.questionnaire[idx + 1].userAnswer.isCurrent = true;
    delete retakeQuestionnaire.questionnaire[idx + 1].userAnswer.fromPrevious;
  } else {
    retakeQuestionnaire.isLast = true;
    retakeQuestionnaire.questionnaire[idx].userAnswer.fromPrevious = false;
    retakeQuestionnaire.questionnaire[idx].userAnswer.isCurrent = false;
  }
  retakeQuestionnaire.percentage += 100 / retakeQuestionnaire.questionnaire.length;
};
export default PatientAnswersApi;
